import { FileParseFormatColumnDto } from './FileParseFormatColumnDto';
import { FileParseFormatFileExtensionDto } from './FileParseFormatFileExtensionDto';
import { FileParseFormatCalculationDto } from './FileParseFormatCalculationDto';

export interface FileParseFormatDto {
  FileParseFormatId?: Guid;
  Name?: string;
  FileExtensions: FileParseFormatFileExtensionDto[];
  FileParseFormatColumns: Array<FileParseFormatColumnDto>;
  DeletedFileParseFormatColumns: Array<FileParseFormatColumnDto>;
  FileParseFormatCalculations: Array<FileParseFormatCalculationDto>;
}

export function GetDefaultFileParseFormatDto(): FileParseFormatDto {
  return {
    FileExtensions: [],
    FileParseFormatColumns: [],
    DeletedFileParseFormatColumns: [],
    FileParseFormatCalculations: []
  };
}
